module.exports = __webpack_public_path__ + "static/media/bdrive.8f0e9c77.svg";